import { Component, OnInit, ChangeDetectorRef, ViewChild, DestroyRef, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ToastPosition, GtToastComponent } from '../../core/components/gt-toast/gt-toast.component';
import { AlertService } from '../../core/services/alert.service';
import { AuthRoutes } from '../../oauth/models/routes/AuthRoutes.constant';
import { LoginChallengeDataService } from '../../core/services/login-challenge-data.service';
import { DomainDataService } from '../../core/services/domain-data.service';
import { LOGO } from '../../core/models/logo.enum';
import { FooterComponent } from '../components/footer/footer.component';
import { InfoSliderComponent } from '../components/info-slider/info-slider.component';
import { GtCompanyLogoComponent } from '../../core/components/gt-company-logo/gt-company-logo.component';
import { NgIf } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'uas-portal',
    templateUrl: 'uas-portal.component.html',
    styleUrls: ['uas-portal.component.scss'],
    imports: [NgIf, GtCompanyLogoComponent, RouterOutlet, InfoSliderComponent, FooterComponent, GtToastComponent]
})
export class UasPortalComponent implements OnInit {
  public position = ToastPosition.TOP_CENTER;
  public showSidebar = true;
  public maintenanceMsg: string = null;
  public loginChallenge = '';
  public domainName = '';
  public clientLogo = LOGO.CLIENT;

  private destroyRef = inject(DestroyRef);

  @ViewChild(RouterOutlet) outlet!: RouterOutlet;

  public get allowedRoutes(): any[] {
    return [AuthRoutes.LOGIN, AuthRoutes.FORGET_PASSWORD, AuthRoutes.TWO_FACTOR_LOGIN,AuthRoutes.LOGOUT, AuthRoutes.ERROR,
      AuthRoutes.RESET_PASSWORD, AuthRoutes.RESET_PASSWORD_SUCEESS, AuthRoutes.SAML_ERROR,
      AuthRoutes.MAINATENANCE_NOTICE, AuthRoutes.CHANGE_PASSWORD, AuthRoutes.CHALLENGE_EXPIRY_ROUTE,  AuthRoutes.DISABLE_NOTICE];
  }

  constructor(
    private router: Router,
    private alertService: AlertService,
    private _loginChallengeDataService: LoginChallengeDataService,
    private _domainDataService: DomainDataService,
    private _cdRef: ChangeDetectorRef
  ) {
    this.routeSubscriber = this.routeSubscriber.bind(this);
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.routeSubscriber);
  }

  public ngOnInit(): void {
    this.loginChallenge = this._loginChallengeDataService.getLoginChallenge();
    this._domainDataService.setDomainIfNotExists();
    this.domainName = this._domainDataService.getDomain();

    this.alertService.getMessageStream()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((note: any) => {
        if (note.hasOwnProperty('message')) {
          this.maintenanceMsg = note.message;
        }
      });
    this._loginChallengeDataService.loginChallengeSource
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this._setLoginCallenge.bind(this));
    this._domainDataService.domainSource
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this._setDomainName.bind(this));
  }
  private routeSubscriber(event) {
    if (event instanceof NavigationEnd) {
      const url = event.url;
      this.showSidebar = this.allowedRoutes.some((route) => url.startsWith(route));
    }
  }

  private _setLoginCallenge(value): void  {
    this.loginChallenge = value;
    const component = this.outlet?.component;
    if (component) {
      const componentRef = (component as any)?._cdRef;
      componentRef?.detectChanges();
    }
    this._cdRef.detectChanges();
    
  }
  private _setDomainName(value): void {
    this.domainName = value;
    this._cdRef.detectChanges();
  }
}
